'use client';
import { useState, useRef, useCallback } from 'react';
import { getVideoComments } from '../api/streams/commonApi';
import { transformStreamComment } from '../utils/transformStreamResponse';
import { useProfileStore } from '../store/useProfileStore';

export const useComments = (feedDetail: any) => {
  const [commentsData, setCommentsData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const fetchingDataRef = useRef(false);
  const paginate = useRef({ start: 0, count: 10 });
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);

  const loadComments = useCallback(
    async (start: number = 0) => {
      if (!feedDetail || !hasUserLoggedIn() || fetchingDataRef.current) return;

      fetchingDataRef.current = true;
      if (start === 0) {
        setCommentsData([]);
      }

      try {
        setLoading(true);
        const payload = {
          id: feedDetail?.id,
          start,
          count: paginate.current.count,
        };
        const res = await getVideoComments(payload);
        if (res && res.data?.length) {
          const comments = transformStreamComment(res);
          setCommentsData((prev) => (start === 0 ? comments : [...prev, ...comments]));
        }
      } catch (error) {
        console.error('Error loading comments:', error);
      } finally {
        setLoading(false);
        fetchingDataRef.current = false;
      }
    },
    [feedDetail]
  );

  const resetComments = useCallback(() => {
    paginate.current.start = 0;
    loadComments(0);
  }, [loadComments]);

  const loadMoreComments = useCallback(async () => {
    paginate.current.start += paginate.current.count;
    await loadComments(paginate.current.start);
  }, [loadComments]);

  return { commentsData, loading, resetComments, loadMoreComments,setCommentsData ,setLoading};
};
